const isTraceEnabled = import.meta.env.VITE_DEBUG_REQUEST_TRACING === 'true';

const now = () => new Date().toISOString();

export const traceLog = (scope: string, message: string, data?: unknown) => {
  if (!isTraceEnabled) return;

  if (data !== undefined) {
    console.debug(`[trace:${scope}] ${now()} ${message}`, data);
    return;
  }

  console.debug(`[trace:${scope}] ${now()} ${message}`);
};

export const shouldTraceRequest = (url: string) =>
  url.includes('/sessions/current') ||
  url.includes('/sessions/') ||
  url.includes('/transcripts') ||
  (url.includes('/campaigns/') && url.includes('/sessions')) ||
  (url.includes('/campaigns/') && url.includes('/players'));
